import * as React from "react";

import { cn } from "@lab/src/lib/util";
import { formatShortcut } from "../../hooks/useKeyboardShortcut";

export interface KbdProps extends React.HTMLAttributes<HTMLElement> {
	/**
	 * Shortcut string like "mod+shift+k", formatted for the current platform
	 * (⌘⇧K on Mac, Strg+⇧+K elsewhere). Alternatively pass children directly.
	 */
	shortcut?: string;
}

const Kbd = React.forwardRef<HTMLElement, KbdProps>(
	({ className, shortcut, children, ...props }, ref) => {
		return (
			<kbd
				ref={ref}
				className={cn(
					"pointer-events-none inline-flex h-5 select-none items-center rounded border bg-muted px-1.5 font-mono text-[10px] font-medium text-foreground/70",
					className
				)}
				{...props}
			>
				{shortcut ? formatShortcut(shortcut) : children}
			</kbd>
		);
	}
);
Kbd.displayName = "Kbd";

export { Kbd };
